module.exports = __webpack_public_path__ + "img/happy.d1fad233.png";